import script from "./FilesUpload.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilesUpload.vue?vue&type=script&setup=true&lang=ts"

import "./FilesUpload.vue?vue&type=style&index=0&id=0c29fd61&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c29fd61"]])

export default __exports__